import React from "react";
import {
  FaUserCheck,
  FaMoneyBillAlt,
  FaLaptopCode,
  FaPlayCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const features = [
  {
    title: "Free Assessment",
    icon: <FaUserCheck className="text-3xl md:text-4xl" />,
    link: "/exam-selection",
  },
  // {
  //   title: "Affordable",
  //   icon: <FaMoneyBillAlt className="text-3xl md:text-4xl" />,
  //   link: "/learn-more",
  // },
  {
    title: "Online Practice",
    icon: <FaLaptopCode className="text-3xl md:text-4xl" />,
    link: "/exam-selection",
  },
  {
    title: "Testimonials",
    icon: <FaMoneyBillAlt className="text-3xl md:text-4xl" />,
    link: "/learn-more",
  },
];

const ExamsSection = () => {
  return (
    <section className="bg-[#1E1032] text-white rounded-xl md:rounded-2xl px-4 py-8 md:px-6 md:py-10 max-w-7xl mx-auto mt-8 md:mt-16 mb-8 md:mb-16 shadow-md md:shadow-lg">
      {/* Header section */}
      <div className="text-left mb-6 md:mb-8">
        <h2 className="text-2xl md:text-4xl font-semibold mb-2 md:mb-4 text-yellow-400">
          Exams
        </h2>
        <p className="text-base md:text-lg text-gray-300">
          Lets walk this journey together....
        </p>
      </div>

      {/* Features grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="text-left p-4 md:p-6 rounded-xl md:rounded-2xl transition-all duration-300 bg-teal-400 text-white shadow-lg transform hover:scale-[1.02] md:hover:scale-[1.05] hover:bg-teal-500"
          >
            <div className="text-white mb-3 md:mb-4 flex justify-start">
              {feature.icon}
            </div>
            <h3 className="font-semibold mb-2 text-lg md:text-xl">
              {feature.title}
            </h3>
            <div className="flex justify-end mt-4">
  <Link
    to={feature.link}
    className="inline-flex items-center gap-1 md:gap-2 text-xs md:text-sm font-semibold bg-yellow-500 text-white py-1 md:py-2 px-3 md:px-4 rounded-full hover:bg-yellow-600 transition-all duration-300"
  >
    Learn More
    <span>&rarr;</span>
  </Link>
</div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default ExamsSection;